export const EventType = {
  Spire: "spire",
  Outlook: "outlook",
} as const;

export interface Event {
  id: string;
  start: Date;
  end: Date;
  title: string;
  description: string;
  type: (typeof EventType)[keyof typeof EventType];
}

export interface TimeSlot {
  start: Date;
  end: Date;
  type?: (typeof EventType)[keyof typeof EventType];
  pre?:number;
  post?:number;
  isOutlook?:boolean;
}
